// extracted by mini-css-extract-plugin
export default {"path":"path-m6o7","parents":"parents-zQOp"};